import { NgTemplateOutlet } from '@angular/common'
import { Component, ContentChild, inject, Input, TemplateRef } from '@angular/core'
import { ControlContainer, NgForm, ValidationErrors } from '@angular/forms'

import { Memoize } from 'typescript-memoize'

@Component({
  selector: 'app-error',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  template: `
    @if (form.controls[fieldName]?.invalid && !form.controls[fieldName].disabled
         && (form.controls[fieldName].dirty || form.controls[fieldName].touched)) {
      <div>
        @if (hasError(form.controls[fieldName].errors)) {
          <small class="p-error block">
            <ng-content></ng-content>
            <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{ $implicit: form.controls[fieldName].errors }"></ng-template>
          </small>
        }
      </div>
    }
  `,
  imports: [NgTemplateOutlet],
})
export class ErrorComponent {
  protected readonly form = inject(NgForm)

  @ContentChild(TemplateRef) templateRef!: TemplateRef<any>

  @Input({ required: true }) public fieldName!: string
  @Input() public errorTypes!: Array<string>

  @Input() public set errorType (errorType: string) {
    this.errorTypes = [errorType]
  }

  @Memoize()
  protected hasError (errors: ValidationErrors | null | undefined) {
    if (!errors) return false
    return Object.keys(errors).some(errorType => this.errorTypes.includes(errorType))
  }
}
